import React from "react";
import { useTable, Column } from "react-table";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/hooks";
import { formatOrderDate } from "../../../../lib/formatOrderDate";
import { Order, OrderStatus, orderStatusToText, dumpsterSizeToText, DumpsterSize } from "../../../../models";

export function AdminActiveOrdersTable() {
  const orders = useAppSelector((s) => s.customerOrders.activeOrders);
  const columns: Array<Column<Order>> = React.useMemo(() => [
    { Header: "Address", accessor: (c) => `${c.address}, ${c.zip}`, id: "address" },
    { Header: "Dumpster Size", accessor: (c) => dumpsterSizeToText[c.dumpsterSize as DumpsterSize], id: "size" },
    { Header: "Delivery Date", accessor: (c) => formatOrderDate(c.deliveryDate), id: "delivery"},
    { Header: "Status", accessor: (c) => orderStatusToText[c.status as OrderStatus], id: "status" },
    { Header: "Actions", accessor: "id", Cell: ({ value }) => (<Link to={`/customer_orders/${value}`} className="view-profile-button">View order</Link>) },
  ], []);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data: orders });
  if (orders.length === 0) return <div className="empty-state">No current orders.</div>;
  return (
    <table {...getTableProps()} className="new-table">
      <thead>{headerGroups.map((hg) => (<tr {...hg.getHeaderGroupProps()}>{hg.headers.map((c) => (<th {...c.getHeaderProps()}>{c.render("Header")}</th>))}</tr>))}</thead>
      <tbody {...getTableBodyProps()}>{rows.map((r) => { prepareRow(r); return (<tr {...r.getRowProps()}>{r.cells.map((cell) => (<td {...cell.getCellProps()}>{cell.render("Cell")}</td>))}</tr>); })}</tbody>
    </table>
  );
}
